import { IPlanification, IPlanificationProgressChart } from '@sdk/contracts';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';
import { TFunction } from 'i18next';
import { Line } from 'react-chartjs-2';
import { DefaultTheme } from 'styled-components';

import { useChartData } from './utils/useChartData';
import { useChartOptions } from './utils/useChartOptions';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

type Props = {
  planification: IPlanification | undefined;
  planificationProgress: IPlanificationProgressChart | undefined;
  isPending: boolean;
  colors: DefaultTheme['colors'];
  t: TFunction<'StudentDashboardTranslations'>;
};

export const ProgressWithPlanificationGraph: React.FC<Props> = ({
  planification,
  planificationProgress,
  isPending,
  colors,
  t
}) => {
  const chartData = useChartData({ planificationProgress, colors, t });
  const chartOptions = useChartOptions({ planification, planificationProgress, colors, t });

  if (!planification || isPending) return null;
  if (!planificationProgress || !chartData) return null;

  return (
    <div style={{ width: '100%', height: '150px', position: 'relative' }}>
      <Line data={chartData} options={chartOptions} />
    </div>
  );
};
